var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import "pixi.js";
import { GetSceneBackground } from "../../../graphics/GetSceneBackground";
import { SceneLayer } from "../../scenes/SceneLayer";
var LayerBackground = /** @class */ (function (_super) {
    __extends(LayerBackground, _super);
    function LayerBackground() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.update = function (props) {
            var display = props.display;
            _this.removeChildren();
            if (display != undefined) {
                _this.addChild(display);
                _this.cacheAsBitmap = true;
            }
        };
        _this.shouldUpdate = function () { return _this.children.length === 0; };
        _this.mapState = function (state) { return ({
            display: GetSceneBackground(state.scenes.currentScene.sceneId),
        }); };
        return _this;
    }
    return LayerBackground;
}(SceneLayer));
export { LayerBackground };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/layers/LayerBackground.ts
// module id = 2179
// module chunks = 3